import Loadable from '@loadable/component';
// @ts-expect-error
import install from '@takeshape/redux-little-router/lib/install';
// @ts-expect-error
import normalizeHref from '@takeshape/redux-little-router/lib/util/normalize-href';
import agentRoutes from './agent/routes.js';
import apiExplorerRouters from './api-explorer/routes.js';
import apiKeysRoutes from './api-keys/routes.js';
import assetsRoutes from './assets/routes.js';
import authRoutes from './auth/routes.js';
import billingRoutes from './billing/routes.js';
import cdnRoutes from './cdn/routes.js';
import Redirect from './common/components/redirect/index.js';
import contentRoutes from './content/routes.js';
import dashboardRoutes from './dashboard/routes.js';
import guardrailRoutes from './guardrails/routes.js';
import { history } from './history.js';
import indexLogRoutes from './index-log/routes.js';
import netlifyAddonRoutes from './netlify-addon/routes.js';
import projectRoutes from './project/routes.js';
import schemaRoutes from './schema/routes.js';
import staticSiteRoutes from './sites/routes.js';
import ssoRoutes from './sso/routes.js';
import roleRoutes from './user-roles/routes.js';
import webhooksRoutes from './webhooks/routes.js';
import workbenchRoutes from './workbench/routes.js';
import workflowRoutes from './workflows/routes.js';

const ProjectsList = Loadable(async () => import('./project/components/project-list/index.js'));
const AddToTakeShape = Loadable(async () => import('./add-to-takeshape/components/add-to-takeshape/index.js'));
const ChangeLog = Loadable(async () => import('./changelog/components/changelog-container.js'));

export const routes = {
  ...authRoutes,
  ...netlifyAddonRoutes,
  ...ssoRoutes,
  '/add-to-takeshape': {
    components: { main: Redirect },
    from: /\/add-to-takeshape/,
    to: '/add-pattern'
  },
  '/add-pattern': {
    components: { main: AddToTakeShape }
  },
  '/project/:projectId': {
    ...projectRoutes,
    ...apiKeysRoutes,
    ...cdnRoutes,
    ...webhooksRoutes,
    ...roleRoutes,
    ...billingRoutes,
    components: { main: Redirect },
    from: /\/?$/,
    to: '/branch/production'
  },
  '/project/:projectId/branch/:branch': {
    ...dashboardRoutes,
    ...assetsRoutes,
    ...contentRoutes,
    ...staticSiteRoutes,
    ...apiExplorerRouters,
    ...indexLogRoutes,
    ...workflowRoutes,
    ...guardrailRoutes,
    ...schemaRoutes,
    ...workbenchRoutes,
    ...agentRoutes
  },
  '/project/:projectId/branch': {
    components: { main: Redirect },
    from: /\/?$/,
    to: '/production'
  },
  '/projects': {
    components: { main: ProjectsList },
    '/:projectId*': {
      components: { main: Redirect },
      from: /^\/projects\//,
      to: '/project/'
    }
  },
  '/changelog': {
    components: { main: ChangeLog }
  }
};

const { pathname, search } = window.location;
const location = normalizeHref({ pathname, search });

export default install({ routes, history, location });
